export default __webpack_public_path__ + "static/media/arrow-left-gray.b6a26e79.svg";